import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName, pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@fluentui/react-northstar';
import { svgIconClassName } from '@archipro-design/icons';

export const HelpGuideStepTwo: StyleRule = () => ({
    color: '#171616',
    background: 'white',
    width: pxToRem(280),
    padding: pxArrayToRem([20, 15]),
});

export const Title: StyleRule = () => ({
    backgroundColor: 'white',
    fontSize: pxToRem(12),
    fontWeight: 500,
    lineHeight: pxToRem(16),
    marginBottom: pxToRem(8),
});

export const Step: StyleRule = () => ({
    color: '#9B9B9B',
    float: 'right',
    paddingRight: pxToRem(8),
});

export const Description: StyleRule = () => ({
    fontSize: pxToRem(12),
    fontWeight: 400,
    lineHeight: pxToRem(16),
    marginBottom: pxToRem(16),

    [`& .${svgIconClassName}`]: {
        width: pxToRem(12),
        height: pxToRem(12),
    },
});

export const Button: StyleRule = () => ({
    [`&> .${buttonClassName}`]: {
        color: '#171616',
        borderColor: '#171616',
        borderRadius: pxToRem(4),
        padding: pxArrayToRem([11, 22]),
    },
    [`&> .${buttonClassName}:hover`]: {
        color: '#171616',
        borderColor: '#171616',
    },
    color: '#171616',
    fontSize: pxToRem(12),
    fontWeight: 500,
    lineHeight: pxToRem(16),
});
